import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Studio from "@/pages/Studio";
import Reels from "@/pages/Reels";
import Maker from "@/pages/Maker";
import MakerWorld from "@/pages/MakerWorld";
import Kingsley from "@/pages/Kingsley";
import KingsleyCategory from "@/pages/KingsleyCategory";
import KingsleyPiece from "@/pages/KingsleyPiece";
import KingsleyFitting from "@/pages/KingsleyFitting";
import Contact from "@/pages/Contact";
import ResourceKit from "@/pages/ResourceKit";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminApp from "@/pages/admin/AdminApp";
import Accessibility from "@/pages/Accessibility";
import { MotionPrefProvider } from "@/context/MotionPref";
import CartDrawer from "@/components/CartDrawer";
import { StoreProvider } from "@/context/StoreContext";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";

function Site() {
  return (
    <SmoothScroll>
      <Layout>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/reels" element={<Reels />} />
            <Route path="/maker" element={<Maker />} />
            <Route path="/maker/:worldId" element={<MakerWorld />} />
            <Route path="/kingsley" element={<Kingsley />} />
            <Route path="/kingsley/c/:categoryId" element={<KingsleyCategory />} />
            <Route path="/kingsley/p/:productId" element={<KingsleyPiece />} />
            <Route path="/kingsley/fitting" element={<KingsleyFitting />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/kit-phaedra" element={<ResourceKit />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/accessibility" element={<Accessibility />} />
        </Routes>
      </Layout>
      <CartDrawer />
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MotionPrefProvider>
      <StoreProvider>
        <CartProvider>
          <Routes>
            <Route path="/admin/*" element={<AuthProvider><AdminApp /></AuthProvider>} />
            <Route path="*" element={<Site />} />
          </Routes>
        </CartProvider>
      </StoreProvider>
      </MotionPrefProvider>
      <Toaster position="bottom-left" />
    </BrowserRouter>
  );
}

export default App;
